(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat/assets/javascripts/bigstat-fallback.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat/assets/javascripts/bigstat-fallback.js');
"use strict";


const ReactIcon = svs.ui.ReactIcon;
const BigStatFallback = _ref => {
  let children = _ref.children,
    branding = _ref.branding,
    theme = _ref.theme;
  let color;
  switch (branding) {
    case 'matchen':
    case 'bomben':
    case 'challenge':
      color = 'fc-oddset-700';
      break;
    case 'powerplay':
      color = 'fc-stryktipset';
      break;
    case 'europatipset':
      color = 'fc-europatipset';
      break;
    case 'topptipset':
      color = 'fc-topptipset';
      break;
    case 'stryktipset':
      color = 'fc-stryktipset';
      break;
    default:
      color = 'fc-navy';
      break;
  } 
  return React.createElement("div", {
    className: "big-stat-fallback ".concat(theme)
  }, React.createElement("div", null, React.createElement(ReactIcon, {
    className: "empty-notice-icon",
    color: color,
    icon: "rest",
    size: "1000"
  }), React.createElement("p", {
    className: "fc-navy f-800 empty-notice-text"
  }, children)));
};
setGlobal('svs.components.sportinfo.bigstat.BigStatFallback', BigStatFallback);

 })(window);